import { ICoreState, IMessage, IMessages, IUser, TApiResCities, TApiResRegions } from '@core/models';
import { ActionReducerMap } from '@ngrx/store';
import * as reducers from '@store/reducers';

export interface AppState {
  alerts: IMessage[];
  cities: TApiResCities;
  core: ICoreState;
  messages: IMessages;
  user: IUser;
  regions: TApiResRegions;
}

export const appReducers: ActionReducerMap<AppState> = {
  alerts: reducers.alertsReducer,
  cities: reducers.citiesReducer,
  core: reducers.coreReducer,
  messages: reducers.messagesReducer,
  user: reducers.userReducer,
  regions: reducers.regionsReducer,
};
